module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_250000_500000.65adb630.png";